import classNames from "classnames";
import { DComponent } from "../../../../components/DComponent";
// eslint-disable-next-line no-unused-vars
import { SearchProduct } from "../../../../models/SearchProduct";
import { getPriceText } from "../../../../utils/currency";
import { replaceVariable } from "../../../../utils/string";

class PackageList extends DComponent {

  constructor({
    parent,
    id,
    dataTable = []
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("PackageList"),
    }, true);
    /** @type {[SearchProduct]} */
    this.dataTable = dataTable;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "PackageList");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    this.addData(this.dataTable);
  }

  /**
   * 
   * @param {[SearchProduct]} data 
   * @param {*} isLoadmore 
   */
  addData(data, isLoadmore = false) {
    let htmlTable = ""
    data.forEach((element, index) => {
      htmlTable += replaceVariable(require("html-loader!./item.html"), {
        classStoreColumn: !isLoadmore && index === 0 ? "is-best" : "",
        storeUrl: element.site?.domain,
        storeName: element.site?.name,
        itemPrice: element.checkoutPrice ? getPriceText(element.checkoutPrice, element.checkoutCur) : "",
        shippingFee: element.checkoutPrice ? getPriceText(element.checkoutPrice, element.checkoutCur) : "",
        totalPrice: element.checkoutPrice ? getPriceText(element.checkoutPrice, element.checkoutCur) : "",
        urlVisitSite: element.meta?.currentUrl,
      })
    });
    if (isLoadmore) {
      $("tbody", this.element).append(htmlTable);
    } else {
      $("tbody", this.element).html(htmlTable);
    }

    $("tbody tr", this.element).off("click");
    $("tbody tr", this.element).on("click", (e) => {
      window.open($(e.currentTarget).attr("url"), "_blank");
    })
    this.update();
  }
}

export default PackageList;